module.exports = __webpack_public_path__ + "img/icon4.63e748d0.svg";